import React from 'react';

const Error = () => {
  return (
    <div style={styles.container}>
      <div style={styles.errorText}>404 - Page Not Found</div>
      <p style={styles.description}>
        The page you are looking for might have been removed or is temporarily
        unavailable.
      </p>
      <button style={styles.button} onClick={() => window.history.back()}>
        Go Back
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f8f8f8',
  },
  errorText: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#e74c3c',
  },
  description: {
    fontSize: '1rem',
    color: '#333',
    textAlign: 'center',
    maxWidth: '400px',
    marginBottom: '20px',
  },
  button: {
    padding: '10px 20px',
    fontSize: '1rem',
    fontWeight: 'bold',
    backgroundColor: '#3498db',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '5px',
  },
};

export default Error;
